import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables';
import React from 'react';
import styled from 'styled-components';

import CarouselSlider from '../../components/carouselSlider';
import {pxToEm} from '../../components/globalStyles';
import CarouselAnalyticsScreenshot1Png from '../../media/cloudAnalyticsPageView/carousel_analytics_screenshot_1.png';
import CarouselAnalyticsScreenshot2Png from '../../media/cloudAnalyticsPageView/carousel_analytics_screenshot_2.png';
import CarouselAnalyticsScreenshot3Png from '../../media/cloudAnalyticsPageView/carousel_analytics_screenshot_3.png';
import CarouselAnalyticsScreenshot4Png from '../../media/cloudAnalyticsPageView/carousel_analytics_screenshot_4.png';
import CarouselAnalyticsScreenshot5Png from '../../media/cloudAnalyticsPageView/carousel_analytics_screenshot_5.png';
import CarouselAnalyticsScreenshot6Png from '../../media/cloudAnalyticsPageView/carousel_analytics_screenshot_6.png';
import CarouselAnalyticsScreenshot7Png from '../../media/cloudAnalyticsPageView/carousel_analytics_screenshot_7.png';

//#region Styled Components

const StyledImg = styled.img`
  width: 100%;
  cursor: pointer;
`;

const StyeldImagePreview = styled.div`
  display: flex;
`;

const StyeldTopic = styled.span`
  font-weight: 500;
  font-size: ${pxToEm(20)}em;
  color: ${baseVariables.colors.midnight};
`;

const StyeldDescription = styled.span`
  font-size: ${pxToEm(20)}em;
  color: ${baseVariables.colors.midnight};
`;

//#endregion

export interface ImagePreview {
  image: string;
  topic: string;
  description: string;
}

interface Props {
  onImageClick: (preview?: ImagePreview) => void;
}

const imagePreviews: ReadonlyArray<ImagePreview> = [
  {
    image: CarouselAnalyticsScreenshot1Png,
    topic: 'Metric Comparison',
    description: 'Breakdown metrics and compare performance between devices, locations, CDNs and more'
  },
  {
    image: CarouselAnalyticsScreenshot2Png,
    topic: 'Session Visualization',
    description: 'Explore individual sessions to identify the root cause of issues'
  },
  {
    image: CarouselAnalyticsScreenshot3Png,
    topic: 'Video Bitrate Heatmap',
    description:
      'Optimise your encodings by understanding which bitrates are seen by your viewers and which are redundant'
  },
  {
    image: CarouselAnalyticsScreenshot4Png,
    topic: 'Quality of Experience Comparison',
    description: 'Compare viewer experiences to find commonalities'
  },
  {
    image: CarouselAnalyticsScreenshot5Png,
    topic: 'API Explorer',
    description: 'Query your data with an easy-to-use API builder'
  },
  {
    image: CarouselAnalyticsScreenshot6Png,
    topic: 'Network Explorer',
    description: 'Use network-level insights to debug and find the root cause of errors'
  },
  {
    image: CarouselAnalyticsScreenshot7Png,
    topic: 'Integrations',
    description:
      'Connect Analytics to your favourite visualization tools, including Grafana, Google Data Studio & Tableau'
  }
];

const AnalyticsPreviewCarousel: React.FunctionComponent<Props> = props => {
  return (
    <CarouselSlider speed={1000} infinite={true}>
      {imagePreviews.map(element => (
        <StyeldImagePreview>
          <StyledImg
            src={element.image}
            alt={`${element.topic} preview image`}
            onClick={() => props.onImageClick(element)}
          />
          <p>
            <StyeldTopic>
              {element.topic}
              {' - '}
            </StyeldTopic>
            <StyeldDescription>{element.description}</StyeldDescription>
          </p>
        </StyeldImagePreview>
      ))}
    </CarouselSlider>
  );
};

export default AnalyticsPreviewCarousel;
